import { PageWeb } from '@nucleus/types/web';
import { useWebHostingApi } from '@nucleus/web-theme';
import { UseSuspenseQueryResult, useSuspenseQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type QueryResult = { page: PageWeb };

const createRedirectError = (
  location: string
): AxiosError<{ location: string }> & {
  response: NonNullable<AxiosError<{ location: string }>['response']>;
} =>
  Object.assign(new Error('Redirect'), {
    isAxiosError: true,
    response: {
      data: { location: location },
      status: 301,
      statusText: 'Moved Permanently' as const,
      headers: {},
      config: { headers: {} } as AxiosError['config'],
    },
  }) as AxiosError<{ location: string }> & {
    response: NonNullable<AxiosError<{ location: string }>['response']>;
  };

export const usePostPage = (engineId: string, basePath: string, slug: string): UseSuspenseQueryResult<QueryResult> => {
  const api = useWebHostingApi();
  const result = useSuspenseQuery(
    api.postHub.page.queryOptions({
      hubId: engineId,
      path: slug,
      basePath: basePath,
    })
  );

  const data = result.data;
  if (data !== undefined && data !== null && typeof data === 'object' && 'location' in data) {
    throw createRedirectError((data as { location: string }).location);
  }

  return { ...result, data: data as QueryResult } as UseSuspenseQueryResult<QueryResult>;
};
